import { Box, Typography } from "@mui/material";
import { NHIType } from "../../../../../../utils/constants";
import { NHITypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import AWSEntityCommonDetails from "./AWSEntityCommonDetails";

const AWSSecretDetailsView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <AWSEntityCommonDetails entityData={entityData} />

      {entityData?.subtype === NHIType.AWS_SECRET && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={1}
            flexDirection={"row"}
          >
            <Typography variant={"subtitle2"}>Type</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={NHITypeIconsAndLabels[entityData?.subtype][1]}
            />
          </Box>
        </Box>
      )}
      {entityData?.aws_secret_data?.region && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            alignItems={"center"}
            gap={1}
            flexDirection={"row"}
          >
            <Typography variant={"subtitle2"}>Region</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={2}>
            <TextIntegrationStyle
              title={""}
              value={entityData?.aws_secret_data?.region}
            ></TextIntegrationStyle>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AWSSecretDetailsView;
